import {Box, Skeleton} from '@mui/material';

const SkeletonNotificationList = () => {
  return (
    <Box sx={{marginTop: '10px', padding: '8px 16px'}}>
      <Skeleton variant='rectangular' width={'100%'} height={'24px'} />
      <Skeleton
        variant='rectangular'
        width={'100%'}
        height={'15px'}
        sx={{marginTop: '5px'}}
      />
    </Box>
  );
};

export default SkeletonNotificationList;
